import { KeyValue } from '@angular/common';
import {Injectable} from '@angular/core';
import {Storage} from '@ionic/storage-angular';
import {Observable, Subject} from 'rxjs';

@Injectable()
export class LocalSettingsService {

  private _storage: Storage | null = null;
  
  public static THEME: string = 'theme';
  public static LANGUAGE: string = 'lang';
  public static MODE: string = 'mode';

  // Observable string sources
  private settingChangedSource: Subject<KeyValue<string, string>> = new Subject<KeyValue<string, string>>();

  // Observable string streams
  public settingChanged$: Observable<KeyValue<string, string>> = this.settingChangedSource.asObservable();


  constructor(private storage: Storage) {
    this.init();
  }

  async init() {
    // If using, define drivers here: await this.storage.defineDriver(/*...*/);
    const storage = await this.storage.create();
    this._storage = storage;
  }

  public get(prop: string): Promise<any> {
    return this._storage.get(prop).then((result) => {
        if (result) {
          return result;
        } else {
          return null;
        }
      });
  }

  public set(prop: string, value: any): Promise<any> {
      if ( prop === LocalSettingsService.THEME 
        || prop === LocalSettingsService.LANGUAGE
        || prop === LocalSettingsService.MODE) {
        this.settingChangedSource.next({key: prop, value: value});
      }
      return this._storage.set(prop, value);
  }

  public del(prop: string): Promise<any> {
    if ( this._storage == null) {
      return Promise.resolve();
    }
    return this._storage.remove(prop)
      .then(() => {
        console.log("del " + prop);
      });
  }

  public delByPrefix(propPrefix: string): Promise<any> {
    return this._storage.keys()
      .then((keys) => {
        for (let i = 0; i < keys.length; i++) {
          if (keys[i].indexOf(propPrefix) == 0) {
            this._storage.remove(keys[i])
              .then(() => {
                console.log("del "+keys[i]);
              });
          }
        }
        return;  
      });
}

// waiting for initialization
  public doWaiting(proc: any, cnt: number = 10): void {
    if ( cnt === 0 ) {
      console.log('### doWait failed');
    }
    if ( this._storage == null ) {
      console.log('~ w: '+ cnt);
      setTimeout(() => this.doWaiting(proc, cnt--), 100);
    }
    else {
      proc();
    }
  }
    

}
